import _ from 'lodash';

import worldMap from '../core/map';
import environment from '../environment';

import BroadcastTVLayer from './BroadcastTVLayer';
import BufferAreaLayer from './BufferAreaLayer';
import CitiesLayer from './CitiesLayer';
import ClusterSalesLayer from './ClusterSalesLayer';
import CustomersLayer from './CustomersLayer';
import DirectSalesLayer from './DirectSalesLayer';
import DncFlexibleLayer from './DncFlexibleLayer';
import GreenfieldAreaLayer from './GreenfieldAreasLayer';
import GreenfieldLayer from './GreenfieldLayer';
import NewGreenfieldAreaLayer from './NewGreenfieldAreasLayer';
import NewGreenfieldLayer from './NewGreenfieldLayer';
import BrownfieldLayer from './BrownfieldLayer';
import LocationLayer from './LocationLayer';
import MarkedAreaLayer from './MarkedAreaLayer';
import MarkedAreaAdditionalLayer from './MarkedAreaAdditionalLayer';
import PGTSLayer from './PGTSLayer';
import PointOfInterestLayer from './PointOfInterestLayer';
import ProtectAreaLayer from './ProtectAreaLayer';
import RetentionLayer from './RetentionLayer';
import SelectedAreasLayer from './SelectedAreasLayer';
import ServiceAreaLayer from './ServiceAreaLayer';
import StoresLayer from './StoresLayer';
import TradeAreaLayer from './TradeAreaLayer';
import VoronoiLayer from './VoronoiLayer';
import TollLayer from './TollLayer';
import FuelStationLayer from './FuelStationLayer';
import FarmMachineLayer from './FarmMachineLayer';
import WorkshopPartLayer from './WorkshopPartLayer';
import CustomersAfterSalesLayer from './AfterSales/CustomersAfterSalesLayer';
import StoreAreasAfterSalesLayer from './AfterSales/StoreAreasAfterSalesLayer';
import MarkedAreaAfterSalesLayer from './AfterSales/MarkedAreaAfterSalesLayer';
import MulticriteriaAfterSalesLayer from './AfterSales/MulticriteriaAfterSalesLayer';
import SelectedAreasAfterSalesLayer from './AfterSales/SelectedAreasAfterSalesLayer';
import StoresAfterSalesLayer from './AfterSales/StoresAfterSalesLayer';
import ClientSalesAfterSalesLayer from './AfterSales/ClientSalesAfterSalesLayer';
import DealershipAfterSalesLayer from './AfterSales/DealershipAfterSalesLayer';
import ProtectAreaAfterSalesLayer from './AfterSales/ProtectAreaAfterSalesLayer';
import colorbrewer from '../core/tools/colorbrewer';
import ServiceAreaAfterSalesLayer from './AfterSales/ServiceAreaAfterSalesLayer';
import { ServiceType } from '../../enuns/AfterSales/serviceArea.enum';
import CompanyCustomersPotentialAfterSalesLayer from './AfterSales/CompanyCustomersPotentialAfterSalesLayer';
import MallCentersLayer from './MallCentersLayer';

const Layers = (() => {
    const _mapLayers = new Map();

    const _layersType = {
        // After Sales
        // Essa ordem é ordem de exibição das camadas na sidebar
        NetworkAfterSales: (currentMap) => new StoresAfterSalesLayer('NetworkAfterSales', currentMap),
        CompetitorsAfterSales: (currentMap) => new StoresAfterSalesLayer('CompetitorsAfterSales', currentMap),
        StoreInactiveAfterSales: (currentMap) => new StoresAfterSalesLayer('StoreInactiveAfterSales', currentMap),
        ClientSalesAfterSales: (currentMap) => new ClientSalesAfterSalesLayer(currentMap),
        CustomersAfterSales: (currentMap) => new CustomersAfterSalesLayer(currentMap),
        StoreAreasAfterSales: (currentMap) => new StoreAreasAfterSalesLayer(currentMap),
        MarkedAreaAfterSales: (currentMap) => new MarkedAreaAfterSalesLayer(currentMap),
        MulticriteriaAfterSales: (currentMap) => new MulticriteriaAfterSalesLayer(currentMap),
        SelectedAreasAfterSales: (currentMap) => new SelectedAreasAfterSalesLayer(currentMap),
        DealershipAfterSales: (currentMap) => new DealershipAfterSalesLayer(currentMap),
        ProtectAreaDealershipAfterSales: (currentMap) => new ProtectAreaAfterSalesLayer(currentMap, colorbrewer.Paired['12']),
        ProtectAreaNetworkAfterSales: (currentMap) => new ProtectAreaAfterSalesLayer(currentMap, colorbrewer.Set3['12']),
        ProtectAreaCompetitorsAfterSales: (currentMap) => new ProtectAreaAfterSalesLayer(currentMap, colorbrewer.RdGy['11']),
        ServiceAreaNetworkAfterSales: (currentMap) => new ServiceAreaAfterSalesLayer(currentMap, {
            remote: true,
            serviceType: ServiceType.Real
        }),
        ServiceAreaTheoreticalNetworkAfterSales: (currentMap) => new ServiceAreaAfterSalesLayer(currentMap, {
            remote: true,
            serviceType: ServiceType.Theoretical,
            isTheoretical: true
        }),
        CompanyCustomersPotentialAfterSales: (currentMap) => new CompanyCustomersPotentialAfterSalesLayer(currentMap),

        // Montadora
        BroadcastTV: (currentMap) => new BroadcastTVLayer(currentMap),
        BufferArea: (currentMap) => new BufferAreaLayer(currentMap),
        Cities: (currentMap) => new CitiesLayer(currentMap),
        ClusterSales: (currentMap) => new ClusterSalesLayer(currentMap),
        Competitors: (currentMap) => new StoresLayer(environment.get('CONFIG.COMPETITORS'), 'Competitors', currentMap),
        Customers: (currentMap) => new CustomersLayer(currentMap),
        DncFlexible: (currentMap) => new DncFlexibleLayer(currentMap),
        Dealerships: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'Dealerships', currentMap),
        StoresMotocycle: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'StoresMotocycle', currentMap),
        StoresConsortium: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'StoresConsortium', currentMap),
        StoreInactive: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'StoreInactive', currentMap),
        UnapprovedStores: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'UnapprovedStores', currentMap),
        StorePlanned: (currentMap) => new StoresLayer(environment.get('CONFIG.DEALERS'), 'StorePlanned', currentMap),
        Greenfield: (currentMap) => new GreenfieldLayer(currentMap),
        NewGreenfield: (currentMap) => new NewGreenfieldLayer(currentMap),
        Brownfield: (currentMap) => new BrownfieldLayer(currentMap),
        DirectSales: (currentMap) => new DirectSalesLayer(currentMap),
        GreenfieldArea: (currentMap) => new GreenfieldAreaLayer(currentMap),
        NewGreenfieldArea: (currentMap) => new NewGreenfieldAreaLayer(currentMap),
        BrownfieldArea: (currentMap) => new NewGreenfieldAreaLayer(currentMap),
        Location: (currentMap) => new LocationLayer(currentMap),
        MarkedArea: (currentMap) => new MarkedAreaLayer(currentMap),
        MarkedAreaAdditional: (currentMap) => new MarkedAreaAdditionalLayer(currentMap),
        PGTS: (currentMap) => new PGTSLayer(currentMap),
        WorkshopPart: (currentMap) => new WorkshopPartLayer(currentMap),
        PointOfInterest: (currentMap) => new PointOfInterestLayer(currentMap),
        Retention: (currentMap) => new RetentionLayer(currentMap),
        SelectedAreas: (currentMap) => new SelectedAreasLayer(currentMap),
        AreaClient: (currentMap) => new MarkedAreaLayer(currentMap),
        ServiceArea: (currentMap) => new ServiceAreaLayer(currentMap),
        TradeArea: (currentMap) => new TradeAreaLayer(currentMap),
        Voronoi: (currentMap) => new VoronoiLayer(currentMap),
        Toll: (currentMap) => new TollLayer(currentMap),
        FuelStation: (currentMap) => new FuelStationLayer(currentMap),
        FarmMachine: (currentMap) => new FarmMachineLayer(currentMap),
        ProtectAreaUnapprovedStores: (currentMap) => new ProtectAreaLayer(currentMap, colorbrewer.Set3['12']),
        MallCenters: (currentMap) => new MallCentersLayer(currentMap),
    };

    const _createLayer = (type, currentMap) => {
        if (_layersType[type]) {
            const mapId = currentMap._id;
            const layers = _mapLayers.get(mapId) || {};

            layers[type] = _layersType[type](currentMap);

            _mapLayers.set(mapId, layers);
        }
    };

    const getMapLayer = (name, id = worldMap.getCurrent()._id) => (_mapLayers.get(id) || {})[name];

    const check = (name, currentMap = worldMap.getCurrent()) => {
        if (!getMapLayer(name, currentMap._id)) {
            _createLayer(name, currentMap);
        }
    };

    const get = (name, currentMap = worldMap.getCurrent()) => {
        check(name, currentMap);
        return getMapLayer(name, currentMap._id);
    };

    const getAll = (id = worldMap.getCurrent()._id) => _mapLayers.get(id);

    const getCurrentFeatures = (name) => {
        check(name);
        return getMapLayer(name).getCurrentFeatures();
    };

    const getLayer = (name, id) => {
        check(name);
        return getMapLayer(name).getLayer(id);
    };

    const removeLayers = (id) => {
        if (_mapLayers.has(id)) {
            _mapLayers.delete(id);
        }
    };

    const clear = (name) => {
        check(name);
        const layer = getMapLayer(name);
        if (layer) {
            layer.clear(true);
        }
    };

    const hide = (name) => {
        check(name);
        const layer = getMapLayer(name);
        if (layer) {
            layer.hide();
        }
    };

    const reload = (name) => {
        check(name);
        getMapLayer(name).reload();
    };

    const reset = (name) => {
        check(name);
        getMapLayer(name).reset();
    };

    const setOptions = (name, options) => {
        check(name);
        if (getMapLayer(name) && _.isFunction(getMapLayer(name).setOptions)) {
            getMapLayer(name).setOptions(options);
        }
    };

    const show = (name) => {
        check(name);
        getMapLayer(name).redraw();
    };

    return {
        clear,
        check,
        get,
        getAll,
        getLayer,
        getCurrentFeatures,
        hide,
        reload,
        removeLayers,
        reset,
        setOptions,
        show
    };
})();

export default Layers;



// WEBPACK FOOTER //
// ./src/scripts/layers/index.js